module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/logo-red-078f44cd6fcfa6e93dee107540bd46c9.svg";